import React from 'react';
import { connect } from 'react-redux';
import './maintenance.scss';
import Spinner from 'components/shared/Spinner';
import BuildIcon from '@material-ui/icons/Build';
import UpdateIcon from '@material-ui/icons/Update';
import { useMaintenanceContext } from 'contexts/MaintenanceContext';
import { convertUTCToLocal } from 'util/maintenanceTime';
import { MAINTENANCE_CONFIG } from 'constants/maintenance';

const Maintanence = ({ routesLoading }) => {
    const { maintenanceSchedule } = useMaintenanceContext();

    let content = <div className="mainWrapper"><Spinner /></div>;
    if (!routesLoading) {
        content = (
            <div className="maintenance-page">
                <div className="maintenance-content">
                    <div className="maintenance-header">
                        <img className='maintenance-image' src={maintenanceSchedule?.Image} alt={maintenanceSchedule?.Title} />
                        <h1>{maintenanceSchedule?.Title}</h1>
                        <p className="maintenance-description">
                            {maintenanceSchedule?.Message}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return content;
};


const mapStateToProps = state => {
    return {
        links: state.layout.routes,
        lang: state.layout.iso,
        routesLoading: state.layout.loading
    };
};


export default connect(
    mapStateToProps,
    null
)(Maintanence);